
<template>
<div class="app-container" :class="$common.app_class" :style="$common.app_style">

  <div class="space" v-if="($common.app_top||$common.video_play_page)&&$common.qr.type!='0'">
    
  </div>

  <router-view></router-view>

  <EwmFooter :footer="footer"/>

</div>
<Toast position="center"/>
<ConfirmDialog></ConfirmDialog>
<DynamicDialog />
</template>

<script>
import EwmFooter from './components/EwmFooter.vue';
import Toast from 'primevue/toast';
import DynamicDialog from 'primevue/dynamicdialog';
import ConfirmDialog from 'primevue/confirmdialog';

export default {
  name: 'App',
  components: {
    EwmFooter,
    Toast,
    DynamicDialog,
    ConfirmDialog
  },
  data() {
    return {
      footer:''
    }
  },
  methods:{

  },
  created(){

    
  },
  mounted(){

    

  },
  updated(){

    this.footer=this.$common.generateKey();

  }

  
}
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  body{
    margin:0px !important;
  }
  p{
    margin:0;
    word-wrap:break-word;
  }
  .app-container{
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .horizontal-margin{
      padding:0 10px;
  }
  .space{
      flex-grow: 1;
      flex-shrink: 1;
  }
</style>
